module.exports = __webpack_public_path__ + "static/banner-1-4a860686f378ba174755235e3408bd61.jpg";